import { Inject, Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import {EnvLocalService} from '../services/env-local.service'
import { EnvDevService } from './env-dev.service';
import { EnvQAService } from './env-qa.service';
import { EnvStageService } from './env-stage.service';
import { EnvDemoService } from './env-demo.service';
import { EnvTrainingService } from './env-training.service';
import { EnvCdssDevService } from './env-cdss-dev.service';
import { EnvCdssQaService } from './env-cdss-qa.service';
import { EnvCdssSitService } from './env-cdss-sit.service';
import { EnvCdssIntService } from './env-cdss-int.service';
import { EnvMagellanDevService } from './env-magellandev.service';
import { EnvMagellanQaService } from './env-magellanqa.service';
import { EnvProd1Service } from './env-prod1.service';
import { EnvProdService } from './env-prod.service';
import { EnvCdssPerfService } from './env-cdss-perf.service';
import { EnvCDSSProdService } from './env-cdss-prod-service'
import { EnvMagellanUatService } from './env-magellan-uat.service';
import { EnvCdssTrnService } from './env-cdss-trn.service';
import { EnvMagellanProdService } from './env-magellanprod.service';
import { EnvMagellanTrainingService } from './env-magellantraining.service';
export interface EnvDomainVariables  {
        _enableErrorLogging: boolean,
        isMagellan ?: string,
        _env: string,
        _apiUrl: string,
        _production: boolean,
        _redirectUri: string,
        _responseType: string,
        _issuer:string,
        _strictDiscoveryDocumentValidation: boolean,
        _tokenEndpoint:string,
        _loginUrl:string,
        _clientId: string,
        _scope:string,
        _skipIssuerCheck: boolean,
        _clearHashAfterLogin: boolean,
        _oidc: boolean,
        _logoutUrl:string,
        _signInURL:string,
        _signInURLSSO:string,
        _adb2cTenantUrl:string,
        _magicLink:string,
        _oktaClientId?: string,
        _oktaIssuer?: string,
        _oktaRedirectUri?: string
        _enableRefreshToken?:boolean
        _authEndpoint: string,
        _magicLinkScope? : string,
        _launchDarklyClientId: string,
        _intercomAppId: string
}
export enum Environment {
    Staging = 'staging',
    QA = 'qa',
    Dev = 'dev',
    Local = 'local',
    Prod = 'prod',
    Prod1 = 'prod1',
    Demo = 'demo',
    Training = 'training',
    Magellan_Dev = 'magellan-dev',
    Magellan_QA = 'magellan-qa',
    Magellan_Training = 'magellan-training',
    Magellan_Prod = 'magellan-prod',
    Magellan_UAT = 'magellan-uat',
    Cdss_TRN = 'cdss-trn',
    Cdss_Dev = 'cdss-dev',
    Cdss_QA = 'cdss-qa',
    Cdss_SIT = 'cdss-sit',
    Cdss_INT = 'cdss-int',
    Cdss_PERF = 'cdss-perf',
    Cdss_PROD = 'cdss-prod',
}

@Injectable({
    providedIn: 'root'
})
export class EnvService {
    // tslint:disable-next-line: variable-name
    private _env: Environment;
    // tslint:disable-next-line: variable-name
    private _apiUrl: string;
    // tslint:disable-next-line: variable-name
    private _mockUrl: string;
    // tslint:disable-next-line: variable-name
    private _production: boolean;
    // tslint:disable-next-line: variable-name
    private _apiKey: string;
    // tslint:disable-next-line: variable-name
    private _pageLimit: number;

    private _redirectUri;
    private _responseType;
    private _issuer;
    private _strictDiscoveryDocumentValidation;
    private _tokenEndpoint;
    private _loginUrl;
    private _clientId;
    private _scope;
    private _skipIssuerCheck;
    private _clearHashAfterLogin;
    private _oidc;
    private _logoutUrl;
    private _signInURL;
    private _signInURLSSO;
    private _adb2cTenantUrl;
    private _magicLink;
    private _enableErrorLogging;
    private _oktaClientId?;
    private _oktaIssuer?;
    private _oktaRedirectUri?;
    private servicesMap: { [key: string]: any };
    private domainInfo: any;
    private _enableRefreshToken;
    private _authEndpoint: string;
    private _magicLinkScope: Environment;
    private _launchDarklyClientId: string;
    private _intercomAppId: string;

    get redirectUri(): Environment {
        return this._redirectUri;
    }

    get signInURL(): Environment {
        return this._signInURL;
    }
    get signInURLSSO(): Environment {
        return this._signInURLSSO;
    }

    get responseType(): Environment {
        return this._responseType;
    }

    get issuer(): Environment {
        return this._issuer;
    }

    get magicLink(): Environment {
        return this._magicLink;
    }

    get oktaClientId(): Environment {
        return this._oktaClientId;
    }

    get oktaIssuer(): Environment {
        return this._oktaIssuer;
    }

    get oktaRedirectUri(): Environment {
        return this._oktaRedirectUri;
    }

    get strictDiscoveryDocumentValidation(): Environment {
        return this._strictDiscoveryDocumentValidation;
    }

    get tokenEndpoint(): Environment {
        return this._tokenEndpoint;
    }

    get scope(): Environment {
        return this._scope;
    }

    get clearHashAfterLogin(): Environment {
        return this._clearHashAfterLogin;
    }

    get skipIssuerCheck(): Environment {
        return this._skipIssuerCheck;
    }

    get oidc(): Environment {
        return this._oidc;
    }

    get logoutUrl(): Environment {
        return this._logoutUrl;
    }

    get clientId(): Environment {
        return this._clientId;
    }

    get loginUrl(): Environment {
        return this._loginUrl;
    }

    get env(): Environment {
        return this._env;
    }

    get apiUrl(): string {
        return this._apiUrl;
    }

    get mockUrl(): string {
        return this._mockUrl;
    }

    get production(): boolean {
        return this._production;
    }

    get apiKey(): string {
        return this._apiKey;
    }

    get listPageLimit(): number {
        return this._pageLimit;
    }

    get adb2cTenantUrl(): string {
        return this._adb2cTenantUrl;
    }

    get enableErrorLogging(): boolean {
        return this._enableErrorLogging;
    }
    get enableRefreshToken(): boolean {
        return this._enableRefreshToken;
    }

    get authEndpoint(): string {
        return this._authEndpoint;
    }
    get MagicLinkScope(): Environment {
        return this._magicLinkScope;
    }

    get magicLinkScope() : string {
        return this._magicLinkScope;
    }

    get launchDarklyClientId(): string {
        return this._launchDarklyClientId;
    }

    get intercomAppId(): string {
        return this._intercomAppId;
    }

    constructor( private injector: Injector) {
      this.servicesMap = {
        'localhost': this.injector.get(EnvLocalService),
        'dev-login.p-cis.com': this.injector.get(EnvDevService),
        'qa-login.p-cis.com' : this.injector.get(EnvQAService),
        'dev2-login.p-cis.com' : this.injector.get(EnvMagellanDevService),
        'qa2-login.p-cis.com' : this.injector.get(EnvMagellanQaService),
        'stage-login.p-cis.com' : this.injector.get(EnvStageService),
        'demo-login.p-cis.com' :  this.injector.get(EnvDemoService),
        'training-login.p-cis.com': this.injector.get(EnvTrainingService),
        'app1.p-cis.com' : this.injector.get(EnvProd1Service),
        'pcis-prod.com': this.injector.get(EnvProdService),
        'uat2-login.p-cis.com' : this.injector.get(EnvMagellanUatService),
        'dev3-login.p-cis.com': this.injector.get(EnvCdssDevService),
        'trn3-login.p-cis.com' : this.injector.get(EnvCdssTrnService),
        'qa3-login.p-cis.com' : this.injector.get(EnvCdssQaService),
        'sit3-login.p-cis.com' : this.injector.get(EnvCdssSitService),
        'int3-login.p-cis.com' : this.injector.get(EnvCdssIntService),
        'perf3-login.p-cis.com' : this.injector.get(EnvCdssPerfService),
        'app3-login.p-cis.com' : this.injector.get(EnvCDSSProdService),
        'app2-login.p-cis.com' : this.injector.get(EnvMagellanProdService),
        'training2-login.p-cis.com' : this.injector.get(EnvMagellanTrainingService),
        };
      this._mockUrl = 'http://demo5957814.mockable.io/test/';
        this._apiKey = '12345';
        this._pageLimit = 20;
    }

    init(): Promise<void> {
        return new Promise(resolve => {
            this.setEnvVariables();
            resolve();
        });
    }
    getService(domain: string): any {
      return this.servicesMap[domain] || this.injector.get(EnvProdService);
    }
    private setEnvVariables(): void {
      const hostname = window && window.location.hostname && window.location.hostname;
      this.domainInfo = this.getService(hostname)?.getDomainInfo();
          this._enableErrorLogging = this.domainInfo?._enableErrorLogging;
          this._enableRefreshToken = this.domainInfo?._enableRefreshToken;
          localStorage.setItem('isMagellan', this.domainInfo?.isMagellan);
          this._env = this.domainInfo?._env;
          this._apiUrl = this.domainInfo?._apiUrl;
          this._production = this.domainInfo?._production;
          this._redirectUri = this.domainInfo?._redirectUri;
          this._responseType = this.domainInfo?._responseType;
          this._issuer = this.domainInfo?._issuer;
          this._strictDiscoveryDocumentValidation = this.domainInfo?._strictDiscoveryDocumentValidation;
          this._tokenEndpoint = this.domainInfo?._tokenEndpoint;
          this._loginUrl = this.domainInfo?._loginUrl;
          this._clientId = this.domainInfo?._clientId;
          this._scope = this.domainInfo?._scope;
          this._skipIssuerCheck = this.domainInfo?._skipIssuerCheck;
          this._clearHashAfterLogin = this.domainInfo?._clearHashAfterLogin;
          this._oidc = this.domainInfo?._oidc;
          this._logoutUrl = this.domainInfo?._logoutUrl;
          this._signInURL = this.domainInfo?._signInURL;
          this._signInURLSSO = this.domainInfo?._signInURLSSO;
          this._adb2cTenantUrl = this.domainInfo?._adb2cTenantUrl;
          this._magicLink = this.domainInfo?._magicLink;
          this._oktaClientId = this.domainInfo?._oktaClientId;
          this._oktaIssuer = this.domainInfo?._oktaIssuer;
          this._oktaRedirectUri = this.domainInfo?._oktaRedirectUri;
          this._authEndpoint = this.domainInfo?._authEndpoint;
          this._magicLinkScope = this.domainInfo?._magicLinkScope;
          this._launchDarklyClientId = this.domainInfo?._launchDarklyClientId;
          this._intercomAppId = this.domainInfo?._intercomAppId;
    }
}
